export enum ApplicationsEnum {
  MYBLACKBIRD = 'myblackbird',
  KITCHEN = 'kitchen',
  CHECKIN = 'checkin',
  COLLECT = 'collect',
  BLACKBIRDGO = 'blackbirdgo',
  DISPENSARY = 'dispensary'
}
